<template>
  <div v-if="!isDdItem" class="hover-cursor position-relative d-inline-block" @click="onViewNotesClick">
    <b-button :id="`notes-view-list-notes-btn-${item.uuid}`"
              variant="primary" size="sm">
      <font-awesome-icon icon="comment-alt" class="icon"/>
    </b-button>
    <b-badge v-if="item && item.total_notes" class="total-notes">
      {{ item.total_notes }}
    </b-badge>
  </div>
  <b-dd-item v-else @click="onViewNotesClick">
    <font-awesome-icon style="font-size: .9em" class="mr-1 icon" icon="comment-alt"/>
    {{ $t("Notes") }}
    <span v-if="totalNotes">
      ({{ totalNotes }})
    </span>
  </b-dd-item>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";

  const {mapActions: notesMapActions} = createNamespacedHelpers('notes');

  export default {
    name: "TableNotesButton",
    props: {
      item: {
        type: Object,
        required: true
      },
      source: {
        type: String,
        required: true
      },
      objectName: {
        type: String,
        required: true
      },
      pluralObjectName: {
        type: String,
        required: true
      },
      changePermission: {
        type: String,
        required: true
      },
      deletePermission: {
        type: String,
        required: true
      },
      hideFooter: {
        type: Boolean,
        required: true
      },
      isDdItem: {
        type: Boolean,
        required: false
      },
      totalNotes: {
        type: [Boolean, String, Number],
        required: false
      },
    },
    methods: {
      ...notesMapActions(['showNoteListModal']),

      async onViewNotesClick() {
        this.showNoteListModal({
          object: this.item,
          source: this.source,
          objectName: this.objectName,
          pluralObjectName: this.pluralObjectName,
          changePermission: this.changePermission,
          deletePermission: this.deletePermission,
          hideFooter: this.hideFooter,
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .total-notes {
    top: -7px;
    right: -7px;
    margin: 0;
    border-radius: 100%;
    padding: 3px 6px;
    font-size: 10px;
    position: absolute;
    background-color: #1ec973;
    color: white;
  }
</style>